export const CORPORATE_LEAD = "CORPORATE_LEAD";
export const APARTMENT_LEAD = "APARTMENT_LEAD";
export const B2BALLIANCES_LEAD = "B2BALLIANCES_LEAD";
export const SUPPLY_LEAD = "SUPPLY_LEAD";
export const CONTRACT_REVENUE = "CONTRACT_REVENUE";
export const CONTRACT_CATEGORY_SERVICES = "CONTRACT_CATEGORY_SERVICES";
export const VALET_CONTRACT_INVOICE = "VALET_CONTRACT_INVOICE";
export const LINE_ITEMS_UPDATE = "LINE_ITEMS_UPDATE";
export const LINE_ITEMS_APPROVAL_LIST = "LINE_ITEMS_APPROVAL_LIST";
export const LINE_ITEMS_BY_INVOICE_ID = "LINE_ITEMS_BY_INVOICE_ID";
export const LINE_ITEMS_APPROVAL_REJECTION = "LINE_ITEMS_APPROVAL_REJECTION";
export const GET_SERVICES = "GET_SERVICES";
export const REVENUE_NATURE = "REVENUE_NATURE";
export const MANAGEMENT_FEE = "MANAGEMENT_FEE";
export const CAPEX_CONTRACT_INVOICE = "CAPEX_CONTRACT_INVOICE";
